import React from 'react';


const TableRowRadioButton = ({ esNueva, descripcion, disable, ID, checked, isVigente, seleccionarEmpresa }) => {

    let descripcionValue;
    let clickFn;

    const cssRadioContainerClass = "container-radio" + (disable && !checked ? "-disabled " : " ") + "radio-margin";
    const labelHoverTitle = (disable) ? "Las empresas de diferente tipo de empresa del seleccionado previamente no pueden ser elegidas" : "";
    descripcionValue = esNueva ? (descripcion + " (Nueva)") : descripcion;

    if (!disable)
        clickFn = () => seleccionarEmpresa(ID);
    else
        clickFn = () => { };

    return (
    <div className="row left-separator-xxs">
        <div className="col-md-12" >
            <div className={cssRadioContainerClass}>
                <input type="radio" name="rb" checked={checked} disabled={disable} id={ID} />
                <label
                    className="lbl-radio label-secondary"
                    htmlFor={ID}
                    onClick={clickFn}
                    title={labelHoverTitle}
                >
                        {descripcionValue}
                </label>
                {isVigente == true ? <label className="lbl-radio label-4" htmlFor={ID}>Vigente</label> : null}
            </div>
        </div>
    </div>
    );
}


export default TableRowRadioButton;